import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function StocktonProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Stockton"
      headingExtra="CA"
      introText="Stockton travelers — Port of Stockton import/export professionals, University of the Pacific students, Delta agricultural exporters, and San Joaquin County families — have several passport options. Here is how they compare, and why most Stockton residents choose a registered State Department courier rather than attempting the deceptive ~80-mile drive to San Francisco for an emergency passport agency appointment."
      options={options}
      emergencyDescription="California has only 2 passport agencies (San Francisco and Los Angeles) serving 39M+ residents — fewer agencies per capita than almost any other large state. Stockton is only ~80 miles from San Francisco — but the distance is deceptive. Central Valley tule fog (Nov–Feb) reduces I-5 visibility to near zero and causes massive multi-car pileups that close the interstate for hours. The Altamont Pass (I-580) is the only direct route to the Bay Area — high winds and truck accidents routinely close this corridor with zero alternate route. The Sacramento-San Joaquin Delta separates Stockton from the Bay Area with only a handful of bridge crossings. San Francisco's single Bay Area agency serves Northern California's 15M+ residents from Monterey to the Oregon border — appointments are fiercely competitive."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}